<ng-container *transloco="let t">
  @if (selectedOrganization() && selectedOrganization()?.accessLevel !== AccessLevel.ADMIN) {
    <div class="row text-danger mx-2 mt-4">
      {{ t("data-warehouse.only_organization_admin_users_have_access_to_data_warehouse") }}
    </div>
  } @else if (selectedOrganization()) {
    @if (selectedOrganization()?.organization?.dataWarehouseFreeTestEndDate === undefined) {
      <IAlert type="info" class="absolute right-6 left-6 z-10 rounded-lg border-blue-500 shadow-md">
        <div class="flex flex-col">
          <span class="mb-2">{{ t("data-warehouse.data_warehouse_not_activated") }}</span>
          <button iButton class="w-fit" (click)="openActivateDataWarehouseModal()">
            {{ t("data-warehouse.activate_data_warehouse") }}
          </button>
        </div>
      </IAlert>
    } @else if ((dataShares() ?? []).length > 0) {
      <div class="flex h-full flex-col py-3">
        <div class="flex items-center justify-between gap-2 px-3.5 pb-3">
          <div iInputGroup>
            <IIcon name="search" />
            <input
              iInputGroupInput
              [placeholder]="t('data-warehouse.search_data_share')"
              [(ngModel)]="filterQuery"
              size="sm"
              class="w-[35rem]"
              [maxLength]="64"
            />
          </div>
          <button iButton (click)="openDataShareCreationModal()">
            <IIcon name="plus" />
            {{ t("data-warehouse-edition.title_create") }}
          </button>
        </div>
        <table class="w-full table-fixed items-center">
          <thead class="bg-slate-50 text-slate-500">
            <tr>
              <th class="w-3/12 px-3.5 py-1.5 text-left text-xs font-normal">
                {{ t("data-warehouse.shares") }}
                <IBadge [label]="displayedDataShares().length.toString()" color="gray" size="xs" />
              </th>
              <th class="w-2/12 text-left text-xs font-normal">{{ t("data-warehouse.status") }}</th>
              <th class="w-2/12 text-left text-xs font-normal">{{ t("data-warehouse.hosting_location") }}</th>
              <th class="w-2/12 text-left text-xs font-normal">{{ t("data-warehouse.accounts") }}</th>
              <th class="w-2/12 text-left text-xs font-normal">{{ t("data-warehouse.granted_to") }}</th>
              <th class="w-2/12 text-left text-xs font-normal">{{ t("data-warehouse.last_push") }}</th>
              <th class="w-2/12"></th>
              <th class="w-1/12"></th>
            </tr>
          </thead>
          <tbody>
            @for (dataShare of displayedDataShares(); track dataShare.shareId) {
              <tr app-data-warehouse-list-item [dataShare]="dataShare"></tr>
            } @empty {
              <tr class>
                <td colspan="7" class="mt-8 text-center text-sm text-gray-700">
                  {{ t("data-warehouse.no_share_matching", [filterQuery()]) }}
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    } @else {
      <div class="flex h-full items-center justify-center">
        <IEmptyState
          class="max-w-sm text-center"
          [title]="t('data-warehouse.no_share')"
          [description]="t('data-warehouse.no_share_description')"
          [ctaLabel]="t('data-warehouse-edition.title_create')"
          (ctaClick)="openDataShareCreationModal()"
        />
      </div>
    }
  }
</ng-container>
